import { render, staticRenderFns } from "./SupplyHall.vue?vue&type=template&id=5d30c42e&scoped=true"
import script from "./SupplyHall.vue?vue&type=script&lang=js"
export * from "./SupplyHall.vue?vue&type=script&lang=js"
import style0 from "./SupplyHall.vue?vue&type=style&index=0&id=5d30c42e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d30c42e",
  null
  
)

export default component.exports